NtechApp.MapList = function($view, mapControls, filters) {
    var me = this;

    this._$view = null;
    this._mapControls = null;
    this._filters = null;

    this._click = null;
    this._sizesResolver = null;
    this._ajax = null;

    this._loader = null;
    this._overlay = null;

    this._nextLoadRequestData = null;
    this._lastLoadRequestData = null;
    this._isListDataLoading = false;

    this._lastResizeDocumentHeight = null;
    this._lastResizeWindowHeight = null;

    this._jobsData = null;

    this._construct = function () {
        me._$view = $view;
        me._mapControls = mapControls;
        me._filters = filters;

        me._click = new NtechApp.TouchClickEvent();
        me._sizesResolver = new NtechApp.SizesResolver();
        me._ajax = new NtechApp.Ajax();

        me._loader = new NtechApp.Loader(
            35, 35, "absolute", this._$view.find("#listLoaderWrap")
        );
        me._overlay = new NtechApp.Overlay(
            this._$view.find(".mapWrapper"),
            {position: "absolute"}
        );

        me._lastResizeDocumentHeight = $(document).height();
        me._lastResizeWindowHeight = $(window).height();

        me._updateListViewWrapHeight();
        this._loaderOn();

        me._loadInitialJobs();

        me._bindEvents();
    }

    this._bindEvents = function () {
        var me = this;

        //$(window).on(NtechApp.MapList.EVENT_WINDOW_RESIZE, function() {
        //    me._lastResizeDocumentHeight = $(document).height();
        //    me._lastResizeWindowHeight = $(window).height();
        //
        //    me._updateListViewWrapHeight();
        //});
        // Map list should always resize before filters from filters resize event
        $(me._filters).on(NtechApp.Filters.EVENT_BEFORE_FILTERS_RESIZE, function() {
            me._triggerResize();
        });

        me._triggerResize = function() {
            me._lastResizeDocumentHeight = $(document).height();
            me._lastResizeWindowHeight = $(window).height();

            me._updateListViewWrapHeight();
        };

        $(document).on(NtechApp.MapList.EVENT_DOCUMENT_SCROLL, function() {
            me._updateListViewWrapHeight();
        });

        $(me._filters).on(NtechApp.Filters.EVENT_FILTER_CHANGE, function(event, filtersData) {
            me._loadJobsData(
                me._lastLoadRequestData.loadJobType,
                filtersData,
                me._lastLoadRequestData.zipCodeId,
                me._lastLoadRequestData.distance,
                me._lastLoadRequestData.mapCenterCoords,
                me._lastLoadRequestData.cityId,
                1
            );
        });

        var mapControls = NtechApp.MapControls;
        $(me._mapControls).on(mapControls.EVENT_ZIP_CONTROL_CHANGE, function(e, zipCodeId, distance) {
            me._loadJobsData(
                NtechApp.Map.LOAD_JOB_TYPES.ZIP_CODES,
                me._filters.getSelectedFilterData(),
                zipCodeId,
                distance,
                me._lastLoadRequestData.mapCenterCoords,
                null,
                1
            );
        });

        $(me._mapControls).on(mapControls.EVENT_CITY_CONTROL_CHANGE, function(e, cityId) {
            me._loadJobsData(
                NtechApp.Map.LOAD_JOB_TYPES.CITIES,
                me._filters.getSelectedFilterData(),
                null,
                null,
                me._lastLoadRequestData.mapCenterCoords,
                cityId,
                1
            )
        });

        me._click.listen(me._$view.find("#listView"), "[data-page]", function(event) {
            event.preventDefault();

            var $page = $(event.target);
            var loadPage = $page.attr("data-page");

            me._loadJobsData(
                me._lastLoadRequestData.loadJobType,
                me._filters.getSelectedFilterData(),
                me._lastLoadRequestData.zipCodeId,
                me._lastLoadRequestData.distance,
                me._lastLoadRequestData.mapCenterCoords,
                me._lastLoadRequestData.cityId,
                loadPage
            );

            return false;
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.MapList.EVENT_WINDOW_RESIZE = "resize.NtechApp.MapList.EventWindowResize";
NtechApp.MapList.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.MapList.EventDocumentScroll";
NtechApp.MapList.LOAD_JOB_TYPES = {
    COORDS: "coords",
    ZIP_CODES: "zipCodes",
    CITIES: "cities"
};

NtechApp.proto(NtechApp.MapList, {
    _loaderOn: function() {
        this._$view.find("#listLoaderWrap").css("display", "block");
        this._loader.on();
        this._overlay.on();
    },

    _loaderOff: function() {
        this._$view.find("#listLoaderWrap").css("display", "none");
        this._loader.off();
        this._overlay.off();
    },

    _updateListViewWrapHeight: function() {
        var headerHeight = $("#mainNavigation").outerHeight();
        var mapControlsHeight = this._mapControls.getView().outerHeight();
        var footerHeight = $("#footer").outerHeight() + 2;

        var $listView = this._$view;
        var listViewStyles = this._sizesResolver.getComputedCss($listView.get(0));
        var listViewPaddingHeight = parseFloat(listViewStyles.paddingTop);
        listViewPaddingHeight += parseFloat(listViewStyles.paddingBottom);

        var contentHeight = headerHeight + mapControlsHeight + footerHeight;
        contentHeight += listViewPaddingHeight;

        var $listViewWrap = this._$view.find("#listViewWrap");
        if(!NtechApp.isMobile() && this._filters.getView().outerHeight() < $(window).height())
            $listViewWrap.css("min-height", this._lastResizeWindowHeight - contentHeight + "px");
        else
            //$listViewWrap.css("min-height", this._lastResizeDocumentHeight - contentHeight + "px");
            $listViewWrap.css("min-height", $listViewWrap.find("#listView").outerHeight() + "px");

        this._$view.find("#listView").css("min-height", this._lastResizeWindowHeight - contentHeight + "px");

        this._updateListLoaderWrapHeight(contentHeight);
    },

    _updateListLoaderWrapHeight: function(contentHeight) {
        this._$view.find("#listLoaderWrap").css("height", this._lastResizeWindowHeight - contentHeight + "px");
    },

    _loadInitialJobs: function() {
        var me = this;

        this._resolveStartCoords(function(startCoords) {
            me._loadJobsData(
                NtechApp.MapList.LOAD_JOB_TYPES.COORDS,
                me._filters.getSelectedFilterData(),
                null,
                null,
                startCoords,
                null,
                1
            );
        });
    },

    _resolveStartCoords: function(cb) {
        var lat = null;
        var lon = null;

        // Miami
        var defCoords = {lat: 25.94154, lng: -80.13861};

        if(NtechApp.isDev) {
            cb(defCoords);
            return;
        }

        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                lat = parseFloat(position.coords.latitude);
                lon = parseFloat(position.coords.longitude);

                cb({lat: lat, lng: lon});
            });
        }
        else {
            cb(defCoords);
            return;
        }
    },

    _loadJobsData: function(loadJobType,
                            filtersData,
                            zipCodeId,
                            distance,
                            coords,
                            cityId,
                            page) {
        this._nextLoadRequestData = {
            loadJobType: loadJobType,
            filtersData: filtersData,
            zipCodeId: zipCodeId || null,
            distance: distance || null,
            coords: coords || null,
            cityId: cityId || null,
            page: page || 1
        };
        if(this._isListDataLoading)
            return;
        this._isListDataLoading = true;

        var me = this;
        this._loaderOn();

        NtechApp.scrollToPx(0, function() {
            me._execLoadJobsData.call(me);
        });
    },

    _execLoadJobsData: function() {
        var me = this;

        this._isListDataLoading = true;

        var requestData = this._nextLoadRequestData;
        var params = {
            loadJobType: requestData.loadJobType,
            filtersData: requestData.filtersData,
            zipCodeId: requestData.zipCodeId,
            distance: requestData.distance,
            coords: requestData.coords,
            cityId: requestData.cityId,
            page: requestData.page,
            responseType: "mapListHtml"
        };

        this._nextLoadRequestData = null;

        me._ajax.get({
            url: Routing.generate('job_load_jobs_data', params),
            onSuccess: function(data) { console.log(data);
                me._isListDataLoading = false;

                if(me._nextLoadRequestData != null) {
                    me._execLoadJobsData.call(me);
                    return;
                }

                me._updateMapData(data, requestData);
                //me._showNotificationIfNoJobsFound();
            },
            onComplete: function() {
                if(me._nextLoadRequestData == null)
                    me._loaderOff();
            }
        });
    },

    _updateMapData: function(data, requestData) {
        var me = this;

        me._jobsData = data.jobs;
        me._lastLoadRequestData = requestData;

        me._lastLoadRequestData.mapCenterCoords = data.mapCenterCoords;
        //me._$view.find(".locationMsg").text(data.locationMsg);

        var $listView = me._$view.find("#listView");
        $.each($listView.children(), function() { $(this).remove(); });

        $listView.append($.parseHTML(data.jobsHtml));

        // Updating filters view
        //$(window).trigger(NtechApp.MapList.EVENT_WINDOW_RESIZE);
        $(window).trigger(NtechApp.Filters.EVENT_FILTERS_RESIZE);
    },

    _showNotificationIfNoJobsFound: function() {
        if(this._jobsData.length == 0)
            NtechApp.info.on("No available jobs found in selected area.", 2500);
    }
});